export default {
  女装: "Женская одежда",
  男装: "Мужской",
  手机和小工具: "Сотовые телефоны и гаджеты",
  居家生活: "семейная жизнь",
  电脑及周边设备: "Компьютеры и периферийное оборудование",
  美容及个人护理: "Красота и уход за собой",
  家用电器: "бытовая техника",
  健康与保健: "здоровье и благополучие",
  食品和饮料: "Продукты питания и напитки",
  玩具_儿童和婴儿: "игрушки, дети и младенцы",
  童装时尚: "детская мода",
  视频游戏: "видеоигры",
  运动与户外: "Спорт и отдых на природе",
  爱好与书籍: "Хобби и книги",
  相机和无人机: "Камеры и дроны",
  宠物食品及用品: "Корм для домашних животных и принадлежности",
  女士包袋: "женские сумки",
  男士包袋: "мужские сумки",
  珠宝及配饰: "Ювелирные изделия и аксессуары",
  手表: "смотреть",
  女鞋: "Женская обувь",
  男装鞋: "Туфли мужские",
  汽车: "машина",
  我附近的ShopeePay: "ShopeePay рядом со мной",
  餐饮_旅行和服务: "Питание, путешествия и услуги",
  旅行及行李: "Путешествие и багаж",
  各种各样的: "Различные виды",
  我是来买什么的: "Что я здесь, чтобы купить?",
  对不起_找不到_相关的商品:
    "К сожалению, товаров, связанных с [{0}], не найдено.",
  类别: "Категория",
  产品: "продукт",
  店铺: "магазин",
  首页: "Главная страница",
  限时秒杀: "Ограниченная по времени флэш-распродажа",
  博客: "блог",
  所有品牌: "Все бренды",
  所有类别: "Все категории",
  我的购物车: "моя корзина покупок",
  发货信息: "информация о доставке",
  交货信息: "Информация о доставке",
  付款: "Оплата",
  确认: "Подтвердить",
  您的购物车是空的: "Ваша корзина пуста",
  价格: "цена",
  税: "Налог",
  数量: "количество",
  总计: "общий",
  移除: "Удалять",
  返回商店: "Вернуться в магазин",
  继续发货: "Продолжить отправку",
  筛选: "фильтр",
  价格范围: "ценовой диапазон",
  排序方式: "Сортировать по",
  最新: "до настоящего времени",
  最旧: "самый старый",
  价格从低到高: "Цена от низкой к высокой",
  价格从高到低: "Цена от высокой к низкой",
  选择交货类型: "Выберите тип доставки",
  送货上门: "Доставка",
  继续付款: "Продолжать платить",
  任何其他信息: "Примечания",
  或者: "или",
  您的钱包余额: "Баланс вашего кошелька",
  余额不足: "Недостаточный баланс",
  支付: "Оплатить",
  我同意: "Я согласен",
  条款和条件: "условия и положения",
  退货政策: "политика возврата",
  隐私政策: "политика конфиденциальности",
  概括: "обобщать",
  项目: "проект",
  全部的: "все",
  小计: "Промежуточный итог",
  总运费: "общая стоимость доставки",
  有优惠码吗_在这里输入: "Есть ли код скидки? Вход здесь",
  申请: "Применять",
  编辑: "редактировать",
  删除: "удалить",
  添加新地址: "Новый адрес",
  继续交货信息: "Продолжить информацию о доставке",
  选择一个地址: "Выберите адрес",
  购买历史: "История покупок",
  下载: "скачать",
  已发送退款请求: "Запрос на возврат отправлен",
  对比: "Сравнение",
  对话: "Диалог",
  我的钱包: "Мой кошелек",
  工单: "заказ на работу",
  管理个人资料: "Управление личными данными",
  登出: "Выйти",
  重置对比列表: "Сбросить список сравнения",
  您的对比列表为空: "Ваш список сравнения пуст",
  在您的购物车中: "в вашей корзине",
  在您的愿望清单中: "в вашем списке желаний",
  在您的预定列表中: "в вашем списке бронирования",
  下载您的产品: "Загрузите свой продукт",
  选项: "Параметры",
  什么都没找到: "Ничего не найдено",
  特色产品: "Рекомендуемые продукты",
  最畅销: "бестселлер",
  前_名: "Топ {0}",
  查看更多: "узнать больше",
  查看所有类别: "Посмотреть все категории",
  十大品牌: "Десять лучших брендов",
  查看所有品牌: "Посмотреть все бренды",
  登录: "Войти",
  手机号码: "Номер телефона",
  密码: "Пароль",
  密码长度为6到16个字符: "Длина пароля от 6 до 16 символов.",
  验证码: "Проверочный код",
  登录中: "Авторизоваться",
  游客登录: "Вход для посетителей",
  注册您的商店: "Зарегистрируйте ваш магазин",
  现在申请: "Подать заявку сейчас",
  成为商家: "Стать торговцем",
  现在注册: "Зарегистрироваться сейчас",
  登录成功: "Приземлился успешно",
  通知: "Уведомления",
  未找到通知: "уведомление не найдено",
  评论: "Комментарий",
  估计运输时间: "Расчетное время доставки",
  天: "небо",
  所售: "продал",
  给商家留言: "Оставьте сообщение продавцу",
  规格: "Спецификация",
  库存: "в наличии",
  总价: "Итоговая цена",
  添加到购物车: "добавить в корзину",
  立即购买: "Купить сейчас",
  缺货: "распродано",
  添加到愿望清单: "Добавить в список желаемого",
  加入对比列表: "Добавить в список сравнения",
  退款: "Возвращать деньги",
  查看条款: "Посмотреть условия",
  分享: "делиться",
  描述: "описывать",
  相关产品: "сопутствующие товары",
  没有人问过商家: "Никто не спросил у торговцев",
  该产品暂无评论: "Отзывов об этом товаре пока нет",
  客户评论: "Отзывы клиентов",
  访问商店: "посетить магазин",
  畅销产品: "Бестселлеры",
  日期: "дата",
  订单编号: "Номер заказа",
  总额: "Общая сумма",
  状态: "состояние",
  愿望清单: "Список желаемого",
  还没有添加任何东西: "Еще ничего не добавлено",
  注册: "регистр",
  邀请码: "Пригласительный код",
  请输入邀请码: "Пожалуйста, введите код приглашения",
  用户名: "имя пользователя",
  请输入用户名: "пожалуйста, введите имя пользователя",
  用户名长度为6_14个字符: "Длина имени пользователя 6-14 символов.",
  昵称: "Никнейм",
  请输入手机号码: "Пожалуйста, введите номер телефона",
  手机号码格式错误: "Неверный формат номера телефона",
  密码长度为6_16个字符: "Длина пароля 6-16 символов.",
  确认密码: "Подтвердите пароль",
  请输入确认密码: "Пожалуйста, введите пароль подтверждения",
  提款密码: "Пароль для оплаты",
  请输入提款密码: "Пожалуйста, введите пароль для вывода средств",
  提款密码长度为4_16个字符: "Длина пароля на вывод составляет 4-16 символов.",
  请输入验证码: "пожалуйста, введите код подтверждения",
  在_s后发送: "Отправлено через {0} с.",
  发送验证码: "Отправить код подтверждения",
  注册即表示您同意我们的条款和条件:
    "Регистрация подтверждает ваше согласие с нашими условиями",
  创建账号: "Завести аккаунт",
  验证码发送成功: "Код подтверждения успешно отправлен",
  确认密码不一致: "Подтвердите, что пароль не соответствует",
  提款密码必须为数字: "Пароль на вывод должен быть числовым",
  注册成功: "Вы успешно зарегистрировались",
  购物车: "корзина",
  账户: "Аккаунт",
  我的账户: "мой счет",
  已经有一个账户: "Уже есть аккаунт",
  新地址: "новый адрес",
  编辑地址: "Изменить адрес",
  保存: "Сохранить",
  是否默认: "Это по умолчанию",
  具体地址: "Подробный адрес, номер дома",
  请输入具体地址: "Пожалуйста, введите конкретный адрес",
  地区: "Регион",
  请输入地区: "Пожалуйста, введите регион",
  城市: "Город",
  请输入城市: "Пожалуйста, введите город",
  省份: "Провинция",
  请输入省份: "Пожалуйста, укажите провинцию",
  邮政编码: "Почтовый индекс",
  请输入邮政编码: "Пожалуйста, введите почтовый индекс",
  电话号码: "номер телефона",
  请输入电话号码: "Пожалуйста, введите свой номер телефона",
  收货人: "Получатель",
  请输入收货人: "Пожалуйста, укажите получателя",
  保存成功: "Успешно сохранено",
  最畅销的商家: "Самые продаваемые торговцы",
  查看所有的商家: "Посмотреть все компании",
  支持政策: "Политика поддержки",
  您的电子邮件地址: "Ваш электронный адрес",
  订阅: "подписка",
  联系方式: "Контактная информация",
  地址: "адрес",
  美国伊利诺伊州霍夫曼庄园: "Хоффман Эстейтс, Иллинойс, США",
  快速链接: "Быстрые ссылки",
  商家政策: "Торговая политика",
  submit: "представлять на рассмотрение",
  提款银行卡: "Вывод на банковскую карту",
  我的面板: "моя панель",
  提示: "намекать",
  确定登出吗: "Вы действительно хотите выйти?",
  确定: "Конечно",
  取消: "Отмена",
  项目添加到您的购物车: "Добавьте товар в корзину",
  经常一起购买: "часто покупаем вместе",
  返回购物: "Вернуться к покупкам",
  进行结算: "перейти к оформлению заказа",
  帮助热线: "Горячая линия",
  查看所有通知: "Просмотреть все уведомления",
  请输入密码: "Пожалуйста введите пароль",
  前往充值: "Перейти на пополнение счета",
  购物车物品: "Товары в корзине",
  查看购物车: "проверить корзину",
  钱包余额: "Баланс кошелька",
  充值钱包: "Пополнить кошелек",
  钱包充值_线下_: "Пополнение кошелька (офлайн)",
  申请提款: "Подать заявку на вывод средств",
  钱包收支明细: "Детали доходов и расходов кошелька",
  批准: "утвердить",
  提现历史记录: "История вывода средств",
  类型: "тип",
  信息: "информация",
  付款方式: "способ оплаты",
  请选择付款方式: "Пожалуйста, выберите способ оплаты",
  Bill_Type_RECHARGE_BACK: "Резервное пополнение",
  Bill_Type_RECHARGE_ONLINE: "Онлайн пополнение",
  Bill_Type_RECHARGE_REGISTER: "Бесплатная регистрация",
  Bill_Type_RECHARGE_JACKPOT: "Бонус пополнения счета",
  Bill_Type_RECHARGE_PRESENT: "Пополнение вознаграждений",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Комиссия за перевод",
  Bill_Type_RECHARGE_TG_COMMISSION: "Пополнение комиссии по продвижению",
  Bill_Type_REGISTER_TG_COMMISSION: "Комиссия по продвижению регистрации",
  Bill_Type_WITHDRAW: "отзывать",
  Bill_Type_WITHDRAW_REJECT: "Вывод отклонен",
  Bill_Type_DEDUCT_HANDLE: "Ручной вычет",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Коррекция перезарядки",
  Bill_Type_MINING_PROFIT: "Доход от майнинга",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Комиссия по поощрению доходов от майнинга",
  Bill_Type_VIP_UPGRADE: "Обновить VIP",
  Bill_Type_FINANCE_BUY: "Приобретение финансовых продуктов",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Возврат финансового баланса",
  Bill_Type_FINANCE_FEE: "Плата за управление финансами",
  Bill_Type_FINANCE_PROFIT: "Доход финансового управления",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Комиссия за приобретение финансовых продуктов",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Комиссия за доход от финансового продукта",
  Bill_Type_WHEEL_DRAW: "Лотерея «Большое колесо»",
  Bill_Type_BUY: "покупать товары",
  Bill_Type_PAY_SHOP: "Оплатить доставку",
  Bill_Type_BUY_COMMISSION: "Комиссия за купленные товары",
  Bill_Type_DEPOSIT: "Оплатить депозит",
  Bill_Type_STORE_BUY: "покупать товары",
  Bill_Type_STORE_BUY_REFUND: "Возврат товара за покупку",
  Bill_Type: "Тип изменения аккаунта",
  Before_Money: "предыдущая сумма",
  Deal_Money: "Сумма изменения счета",
  After_Money: "Сумма после",
  Bill_Time: "Время смены аккаунта",
  No_More_Data: "больше нет данных",
  Apply_Money: "Сумма заявки",
  Apply_Time: "время подачи заявки",
  Withdraw_Info: "Плата за обработку: {fee}, прибытие: {money}",
  提款订单状态_CHECKING: "Ожидает оценки",
  提款订单状态_TRANSFERRING: "Перенос",
  提款订单状态_PASS: "подтвержденный",
  提款订单状态_REJECT: "Уволен",
  暂无可用充值方式: "Способ пополнения пока не доступен.",
  钱包收款码: "Код оплаты кошелька",
  钱包地址: "адрес кошелька",
  金额限制: "Ограничение суммы",
  复制: "копировать",
  付款凭证: "платежный ваучер",
  收款银行: "Банк получателя",
  收款人: "Получатель платежа",
  收款账号: "Номер платежного счета",
  付款银行: "платежный банк",
  付款人: "Плательщик",
  付款账号: "Платежный счет",
  请输入付款银行: "Пожалуйста, укажите банк платежа",
  请输入付款人: "Пожалуйста, укажите плательщика",
  请输入付款账号: "Пожалуйста, введите номер платежного счета",
  请上传付款凭证: "Пожалуйста, загрузите платежный ваучер",
  充值金额: "Сумма пополнения",
  请输入充值金额: "Пожалуйста, введите сумму пополнения",
  submitting: "отправка...",
  Confirm: "представлять на рассмотрение",
  Commit_Success: "Отправлено успешно",
  balanceType_BALANCE: "баланс",
  balanceType_COMMISSION: "комиссия",
  Balance: "Баланс",
  Wash_Money: "добавить мозаику",
  请选择银行账户: "Пожалуйста, выберите банковский счет",
  卡号类型: "Тип номера карты",
  提现金额: "Сумма вывода",
  提款金额: "Сумма вывода",
  不能为空: "Не может быть пустым",
  金额不正确: "Сумма указана неверно",
  please_input_withdraw_password:
    "Пожалуйста, введите пароль для вывода средств",
  withdraw_password_format_error:
    "Пароль на вывод должен состоять из 4-16 символов.",
  Fee: "плата за обработку",
  实际到账: "Фактическое прибытие",
  交易币种: "Валюта транзакции",
  原始密码: "оригинальный пароль",
  confirm_password_error: "Пароль, введенный дважды, неверен",
  save_success: "Успешно сохранено",
  please_input: "Пожалуйста входите",
  old_password: "Старый пароль",
  new_password: "Новый пароль",
  please_input_confirm_password: "Пожалуйста, подтвердите пароль еще раз",
  没有找到符合条件的商品: "Подходящие товары не найдены",
  Search: "поиск",
  全部: "все",
  EnumGoodsOrderState_USER_PAY: "Ожидание доставки",
  EnumGoodsOrderState_SHOP_PAY: "Доставка",
  EnumGoodsOrderState_SUCCESS: "Заканчивать",
  EnumGoodsOrderState_CANCEL: "Отменено",
  EnumGoodsOrderState_REFUND_SUCCESS: "возвращен",
  订单号: "номер заказа",
  用户名称: "имя пользователя",
  收益: "доход",
  支付时间: "Время оплаты",
  配送时间: "Срок поставки",
  完成时间: "Полное время",
  发货: "Корабль",
  全选: "выбрать все",
  物品已添加到愿望清单: "Товар добавлен в список желаний",
  物品已添加到比较列表: "Товар добавлен в список сравнения",
  购买成功提示: "Поздравляем, покупка успешна",
  订单列表: "Список заказа",
  商品名: "Наименование товара",
  图片: "картина",
  没有品牌: "нет бренда",
  基本信息: "Основная информация",
  Account_Name: "Название открытия счета",
  Bank_Account: "Номер счета",
  Bank_Phone: "Зарезервировать номер мобильного телефона",
  IFSC: "счет IFSC",
  UPI: "учетная запись ЮПИ",
  PIX: "учетная запись PIX",
  CPF: "счет CPF",
  GCASH: "счет GCASH",
  POWWI: "учетная запись POWWI",
  身份证号: "идентификационный номер",
  Edit: "Исправлять",
  Delete: "удалить",
  Add: "Добавить",
  Forget_Withdraw_Password: "Забыл пароль для вывода средств",
  Bank_Card_Info: "Данные банковской карты",
  收款人地址: "Адрес получателя платежа",
  SWIFT: "БЫСТРЫЙ",
  Bank_Branch: "Название филиала",
  分行代码: "код филиала",
  银行地址: "Адрес банка",
  Email: "Электронная почта",
  银行卡长度必须超过: "Длина банковской карты должна превышать {length}",
  银行卡格式不正确: "Неверный формат банковской карты",
  Do_you_confirm_delete: "Подтвердить удаление?",
  Please_Login_First: "Пожалуйста, войдите сначала",
  Bank_Name: "Название банка",
  Please_add_bank_first:
    "Банковская карта еще не привязана, добавьте её сначала",
  withdrawType: "Тип вывода",
  withdraw_money_limit:
    "Сумма вывода должна быть больше 0 и меньше или равна {balance}.",
  withdraw_times_limit:
    "Сегодня вы выводили средства {todayWithdrawNum} раз, и через {limitTimes} раз будет снята комиссия за обработку в размере {withdrawFee}%. Вы уверены, что откажетесь?",
  Copy_Success: "Скопировано успешно",
  商店首页: "Домашняя страница магазина",
  所有产品: "Все продукты",
  新到货产品: "Недавно поступившие продукты",
  所有商家: "Все торговцы",
  请上传: "Пожалуйста, загрузите",
  请输入: "Пожалуйста входите",
  忘记密码: "Забыли пароль",
  记得我: "Запомнить пароль",
  共_件: "Всего {0} элементов",
  取消订单: "отменить заказ",
  申请退款: "Запросить возврат средств",
  未知商家: "Неизвестный торговец",
  到账: "Квитанция",
  提款订单状态: "Статус заказа на снятие средств",
  前_名类别: "Топ {0} категорий",
  取消订单原因_不想要了: "Больше не хочу этого",
  取消订单原因_商品错选_多选: "Неправильный выбор продукта/множественный выбор",
  取消订单原因_商品无货: "Товара нет в наличии",
  取消订单原因_地址信息填写错误: "Адресные данные заполнены неверно",
  取消订单原因_商品降价: "Снижение цены на продукцию",
  取消订单原因_价格高于其他平台: "Цена выше, чем на других платформах",
  取消订单原因_没用_少用_错用优惠:
    "Неиспользование/меньшее использование/неправильное использование скидок",
  退款原因_拍错_多拍_不喜欢: "Неправильный выстрел/лишний выстрел/не нравится",
  退款原因_商品成分描述不符: "Описание ингредиентов продукта не соответствует",
  退款原因_与商家协商一致退款: "Возврат по договоренности с продавцом",
  退款原因_生产日期_保质期与商品描述不符:
    "Дата производства/срок годности не соответствует описанию товара.",
  退款原因_图片_产地_批号_规格等描述不符:
    "Фотографии/происхождение/номер партии/технические характеристики и другие описания не совпадают.",
  退款原因_质量问题: "Проблемы качества",
  退款原因_商品变质_发霉_有异物:
    "Товар испорчен/заплесневел/имеет посторонние предметы",
  退款原因_少件_含缺少配件_:
    "Несколько деталей (включая недостающие аксессуары)",
  退款原因_收到商品时有破损_污渍_变形:
    "При получении товар был поврежден/испачкан/деформирован.",
  退款原因_假冒品牌: "Поддельные бренды",
  退款原因_发票问题: "Проблемы со счетами",
  退款原因_商家发错货: "Продавец отправил не тот товар",
  退款原因_预约不到_商家不给退换:
    "Не могу записаться на прием/продавец не осуществляет возврат или обмен.",
  退款失败: "Возврат не выполнен",
  退款处理中: "Возврат средств в процессе",
  默认: "По умолчанию",
  产品查询: "Поиск продукта",
  商店LOGO: "ЛОГОТИП магазина",
  推广码: "Промо-Код",
  查看所有: "посмотреть все",
  确认收货成功: "Подтвердите успешное получение товара",
  物流公司: "Логистическая компания",
  物流单号: "номер отправления",
  发货时间: "Время доставки",
  请先选择商品规格: "Пожалуйста, сначала выберите характеристики продукта",
  个人信息: "Личная информация",
  您的用户名: "ваш логин",
  你的名字: "Ваше имя",
  登录名: "имя пользователя",
  你的邮件: "ваш адрес электронной почты",
  你的密码: "ваш пароль",
  重复输入密码: "Повторите ввод пароля",
  店铺名称: "Название магазина",
  证书类型: "Тип сертификата",
  身份证: "Удостоверение личности",
  护照: "заграничный пасспорт",
  驾驶执照: "водительское удостоверение",
  社会保障卡: "Карточка социального обеспечения",
  证书正面: "Лицевая сторона удостоверения",
  证书反面: "Обратная сторона удостоверения",
  确认收货: "подтвердить получение товара",
  请选择取消订单的原因必选:
    "Пожалуйста, выберите причину отмены заказа (обязательно):",
  请选择申请退款的原因必选:
    "Пожалуйста, выберите причину запроса возврата средств (обязательно):",
  留言: "сообщение",
  请输入留言: "Пожалуйста, введите сообщение",
  没有帐户: "Нет аккаунта",
  钱包充值: "Пополнение кошелька",
  输入您的文字: "Введите ваше сообщение",
  商家登录: "Вход для продавца",
  有关此产品的任何查询: "Любые вопросы об этом продукте",
  产品名称: "наименование товара",
  你的问题: "твоя проблема",
  白银店铺: "серебряный магазин",
  铂金店铺: "платиновый магазин",
  钻石店铺: "алмазный магазин",
  照片: "Фото",
  已退货: "Вернулся",
  邮寄状态: "Статус рассылки",
  订单摘要: "Итог заказа",
  收件地址: "Адрес получателя",
  订购日期: "Дата заказа",
  订单状态: "Статус заказа",
  总订单金额: "Общая сумма заказа",
  邮寄方式: "Способ рассылки",
  附加信息: "Дополнительная информация",
  订单详细信息: "Информация для заказа",
  交货类型: "Тип доставки",
  进行评论: "Оставить комментарий",
  已评论: "Прокомментировал",
  订单金额: "сумма заказа",
  优惠券: "купон",
  统一运费: "Фиксированная стоимость доставки",
  送货地址: "Адрес доставки",
  评分: "счет",
  你的意见: "Твое мнение",
  匿名: "анонимный",
  现金: "наличные",
  详情: "Подробности",
  收货地址: "Адрес доставки",
  暂时没有对话: "Пока нет разговоров",
  你: "ты",
  输入您的回复: "Введите свой ответ",
  删除成功: "успешно удалено",
  品牌: "бренд",
  已缴纳的保证金: "Залог внесен",
  黄金店铺: "золотой магазин",
  没有更多数据: "больше нет данных",
  站内信: "Сообщение сайта",
  系统通知: "системное уведомление",
  邮箱: "Почта",
  手机号: "Номер телефона",
  你的手机号: "ваш номер телефона",
  营业执照: "бизнес-лицензия",
  你的邮箱: "твой почтовый ящик",
  搜索结果: "результаты поиска",
  系统公告: "системное уведомление",
  客服: "обслуживание клиентов",
  消息已撤回: "Сообщение было отозвано",
  物流详情: "Детали логистики",
  充值: "Пополнить",
  提现: "Вывести средства",
  信用分: "кредитный рейтинг",
  余额: "Баланс",
  佣金: "комиссия",
  继续购物: "продолжить покупки",
  订单结算: "Заказать расчет",
  加入对比: "Добавить к сравнению",
  佣金余额: "Баланс комиссий",
  刷新: "обновить",
  刷新成功: "Обновить успешно",
  官网: "Официальный веб-сайт",
  税号: "Идентификационный номер налогоплательщика",
  订单: "Заказ",
  合计: "общий",
  系统安全: "Безопасность системы",
  Recharge_Money_Limit: "Сумма пополнения должна быть между {min} и {max}.",
  限时优惠: "Ограниченное по времени предложение",
  高价回收: "Высокая цена вторичной переработки",
  姓名: "ФИО",
  商品订单号: "Номер заказа продукта",
  商品在线回收: "Переработка продуктов онлайн",
  提交: "Отправить",
  回收记录: "Записи о переработке",
  回收状态: "Статус переработки",
  回收价格: "цена переработки",
  纳税码: "налоговый кодекс",
  买家登录: "Вход для покупателя",
  买家注册: "Регистрация покупателя",
  商家注册: "Регистрация продавца",
  提交审核: "Отправить на проверку",
  language: "俄语",
  助力提示:
    "Помощь торговцам может увеличить воздействие платформы в их магазинах, и чем выше совокупное количество дней, тем выше воздействие.",
  已累计助力: "Кумулятивно помогал",
  今日已助力: "Сегодня помог",
  立即助力: "Помогите немедленно",
  商家助力: "Помощь продавца",
  证件号码: "Идентификационный номер",
  证书号码: "Номер сертификата"
};
